// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTranslate } from "react-localize-redux";

import LandingPage from "../../Components/PublicPages/LandingPage";

type PropsType = {
  translate: (string) => void
};

type StateType = {};

class LandingPageContainer extends Component<PropsType, StateType> {
  render() {
    return <LandingPage {...this.props} />
  }
}

const mapStateToProps = state => {
  return {
    translate: getTranslate(state.locale)
  }
};

const mapDispathToProps = dispatch => {
  return bindActionCreators(
    {
      // actions lies here
    }, dispatch
  )
};

export default connect(mapStateToProps, mapDispathToProps)(LandingPageContainer);



// WEBPACK FOOTER //
// ./src/Containers/PublicPages/LandingPageContainer.js